// @generated
// This file is automatically generated by Kanel. Do not modify manually.

import { z } from 'zod';

/** Represents the enum public.contact_subscriptions */
enum ContactSubscriptions {
  newsletter = 'newsletter',
};

export default ContactSubscriptions;

/** Zod schema for contact_subscriptions */
export const contactSubscriptions = z.enum([
  'newsletter',
]);
